import { useCallback, useEffect } from "react";

type Props = {
  onEscape?: () => void;
};

export const useKeyboardNavigation = ({ onEscape }: Props) => {
  const onKeyDown = useCallback(
    (event: any) => {
      if (event.key === "Escape") {
        onEscape?.();
        return;
      }
    },
    [onEscape]
  );

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown, false);

    return () => {
      document.removeEventListener("keydown", onKeyDown, false);
    };
  }, [onKeyDown]);
};
